module.exports = __webpack_public_path__ + "img/15.1.cc894006.png";